import { Galaktika_BG } from '../../assets/img'
import { AllianceSlider } from '../civilisations/Alliance'
import { AxolotlSlider } from '../civilisations/Axolotl'
import { LuminayanSlider } from '../civilisations/Luminayan'
import { PurgamenSlider } from '../civilisations/Purgamen'
import { RazatechSlider } from '../civilisations/Razatech'
import DefaultLayout from '../layout/defaultLayout'

const ViewStats = ({ civilisation }) => {
  return (
    <DefaultLayout background={Galaktika_BG} pageTitle="My Stats">
      {civilisation === 'Alliance' ? (
        <AllianceSlider component="myStats" />
      ) : civilisation === 'Purgamen' ? (
        <PurgamenSlider component="myStats" />
      ) : civilisation === 'Luminayan' ? (
        <LuminayanSlider component="myStats" />
      ) : civilisation === 'Razatech' ? (
        <RazatechSlider component="myStats" />
      ) : (
        <AxolotlSlider component="myStats" />
      )}
    </DefaultLayout>
  )
}

export default ViewStats
